import type { VipWeeklyRewardEmailReminderPreference } from "~~/shared/atelier";

const VIP_REMINDER_PREFERENCES = new Set<
  VipWeeklyRewardEmailReminderPreference
>(["unset", "enabled", "disabled"]);

export const normalizeVipWeeklyRewardEmailReminderPreference = (
  value: string | null | undefined,
): VipWeeklyRewardEmailReminderPreference => {
  const normalized = String(value || "").trim().toLowerCase();
  return VIP_REMINDER_PREFERENCES.has(
    normalized as VipWeeklyRewardEmailReminderPreference,
  )
    ? (normalized as VipWeeklyRewardEmailReminderPreference)
    : "unset";
};

export const extractVipWeeklyRewardEmailReminderPreference = (
  payload:
    | {
        status?: string | null;
        emailReminderPreference?: string | null;
        vipWeeklyRewardEmailReminder?: string | null;
        preference?: string | null;
      }
    | null
    | undefined,
): VipWeeklyRewardEmailReminderPreference | undefined => {
  const rawPreference =
    payload?.status ??
    payload?.emailReminderPreference ??
    payload?.vipWeeklyRewardEmailReminder ??
    payload?.preference;

  if (rawPreference === undefined || rawPreference === null) {
    return undefined;
  }

  return normalizeVipWeeklyRewardEmailReminderPreference(rawPreference);
};
